import { FLAG_DIAGNOSTIC_SECTIONS } from "./optimization-vitals-constants.js";

export function structuredFlagCount(diag) {
  return diag && typeof diag === "object" && Array.isArray(diag.flags)
    ? diag.flags.length
    : 0;
}

export function parseCylinderFlag(flag) {
  const o =
    typeof flag === "object" && flag != null
      ? flag
      : { text: String(flag ?? "") };
  const text = o.text ?? "";
  const dash = text.indexOf(" - ");
  return {
    text,
    name: o.name ?? null,
    identifier: dash >= 0 ? text.slice(0, dash).trim() : "",
    flagName: dash >= 0 ? text.slice(dash + 3).trim() : text,
    isWarning: /^warning$/i.test(String(o.severity ?? "").trim()),
  };
}

/**
 * Badge count: structured flags per category plus legacy string statuses (non-OK).
 * @param {Record<string, unknown>} flagDiagnostics
 * @returns {number}
 */
export function getFlagDiagnosticsTotalCount(flagDiagnostics) {
  return (
    FLAG_DIAGNOSTIC_SECTIONS.reduce(
      (sum, s) => sum + structuredFlagCount(flagDiagnostics[s.key]),
      0
    )
    + FLAG_DIAGNOSTIC_SECTIONS.filter((s) => {
      const st = flagDiagnostics[s.key];
      return typeof st === "string" && st != null && st !== "OK";
    }).length
  );
}

/**
 * Accordion sections to open by default (structured flags present).
 * @param {Record<string, unknown>} flagDiagnostics
 * @returns {string[]}
 */
export function getDefaultOpenFlagSectionValues(flagDiagnostics) {
  return FLAG_DIAGNOSTIC_SECTIONS.filter(
    ({ key }) => structuredFlagCount(flagDiagnostics[key]) > 0
  ).map(({ value }) => value);
}
